module.exports = __webpack_public_path__ + "img/appIcon-ui--tableSort.f8f080ec.svg";